var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"mobile-nav"},[_c('button',{class:[
      'mobile-nav-btn',
      { 'mobile-nav-btn--active': _vm.activeTab === 'dashboard' },
    ],attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('change-tab', 'dashboard')}}},[_c('span',{staticClass:"icon"},[_vm._v("📊")]),_c('span',{staticClass:"label"},[_vm._v("Início")])]),_c('button',{class:[
      'mobile-nav-btn',
      { 'mobile-nav-btn--active': _vm.activeTab === 'values' },
    ],attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('change-tab', 'values')}}},[_c('span',{staticClass:"icon"},[_vm._v("🏅")]),_c('span',{staticClass:"label"},[_vm._v("Valores")])]),_c('button',{class:[
      'mobile-nav-btn',
      { 'mobile-nav-btn--active': _vm.activeTab === 'communication' },
    ],attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('change-tab', 'communication')}}},[_c('span',{staticClass:"icon"},[_vm._v("💬")]),_c('span',{staticClass:"label"},[_vm._v("Chat")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }